import { render, staticRenderFns } from "./displayStyle-editor.vue?vue&type=template&id=22ce6c1e&scoped=true"
import script from "./displayStyle-editor.vue?vue&type=script&lang=js"
export * from "./displayStyle-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ce6c1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22ce6c1e')) {
      api.createRecord('22ce6c1e', component.options)
    } else {
      api.reload('22ce6c1e', component.options)
    }
    module.hot.accept("./displayStyle-editor.vue?vue&type=template&id=22ce6c1e&scoped=true", function () {
      api.rerender('22ce6c1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/displayStyle-editor.vue"
export default component.exports